export const storeListData = {
    "result": {
        "messages": [],
        "result": {
            "storeList": [
                {
                    "storeID": 1199,
                    "shopCode": "352794061115343",
                    "name": "VODACOM SHOP BOULDERS MIDRAND",
                    "addressLineOne": "Old Pretoria Road",
                    "addressLineTwo": "Shop 26, Boulders Shopping Centre",
                    "city": "Midrand",
                    "district": "Johannesburg",
                    "state": "Southern Gauteng",
                    "country": "ZA",
                    "postalCode": "1685",
                    "mainPhone": "+27114658104",
                    "email": "OmniBBDDevTeam@vodacom.co.za",
                    "alternativePhone": null,
                    "mobilePhone": null,
                    "fax": null,
                    "paymentTypes": [
                        {
                            "paymentTypeDescription": null,
                            "paymentTypeId": 0
                        }
                    ],
                    "additionalPhone": null,
                    "tradingHours": [
                        {
                            "dayOfWeek": 0,
                            "startTime": 0,
                            "endTime": 0
                        }
                    ],
                    "bir": false,
                    "storeCategory": {
                        "categoryID": 4,
                        "description": "Emerging Market"
                    },
                    "open": true,
                    "coordinate": {
                        "latitude": -25.99977,
                        "longitude": 28.12571
                    },
                    "distance": 3.448784277021117,
                    "type": {
                        "typeId": 4,
                        "description": "Vodacom Shop"
                    },
                    "stockReservationEnable": true,
                    "upgradeToCollectEnable": true,
                    "stockCode": null,
                    "quantity": 0,
                    "inStock": false,
                    "lastUpdate": null
                },
                {
                    "storeID": 1327,
                    "shopCode": "23209",
                    "name": "VODACOM SHOP REPAIRS FOURWAYS",
                    "addressLineOne": "Corner William Nicol and Witkoppen Street",
                    "addressLineTwo": "Shop M7C, Fourways Mall",
                    "city": "Fourways",
                    "district": "Johannesburg",
                    "state": "Southern Gauteng",
                    "country": "ZA",
                    "postalCode": "2191",
                    "mainPhone": "27114656716",
                    "email": "OmniBBDDevTeam@vodacom.co.za",
                    "alternativePhone": null,
                    "mobilePhone": null,
                    "fax": null,
                    "paymentTypes": [
                        {
                            "paymentTypeDescription": null,
                            "paymentTypeId": 0
                        }
                    ],
                    "additionalPhone": null,
                    "tradingHours": [
                        {
                            "dayOfWeek": 0,
                            "startTime": 0,
                            "endTime": 0
                        }
                    ],
                    "bir": false,
                    "storeCategory": {
                        "categoryID": 3,
                        "description": "Super Premium"
                    },
                    "open": true,
                    "coordinate": {
                        "latitude": -26.022339,
                        "longitude": 28.008699
                    },
                    "distance": 13.37037840001163,
                    "type": {
                        "typeId": 4,
                        "description": "Vodacom Shop"
                    },
                    "stockReservationEnable": false,
                    "upgradeToCollectEnable": false,
                    "stockCode": "0000000103004940",
                    "quantity": 625,
                    "inStock": true,
                    "lastUpdate": "2020-08-09T01:18:29.0"
                },
                {
                    "storeID": 1345,
                    "shopCode": "27881",
                    "name": "VODACOM SHOP RIVONIA ",
                    "addressLineOne": "Corner Rivonia Boulevard and Mutual Road",
                    "addressLineTwo": "Shop 70, Rivonia Village Shopping Centre",
                    "city": "Rivonia",
                    "district": "Johannesburg",
                    "state": "Southern Gauteng",
                    "country": "ZA",
                    "postalCode": "2499",
                    "mainPhone": "27118074391",
                    "email": "OmniBBDDevTeam@vodacom.co.za",
                    "alternativePhone": null,
                    "mobilePhone": null,
                    "fax": null,
                    "paymentTypes": [
                        {
                            "paymentTypeDescription": null,
                            "paymentTypeId": 0
                        }
                    ],
                    "additionalPhone": null,
                    "tradingHours": [
                        {
                            "dayOfWeek": 0,
                            "startTime": 0,
                            "endTime": 0
                        }
                    ],
                    "bir": false,
                    "storeCategory": {
                        "categoryID": 1,
                        "description": "Standard"
                    },
                    "open": true,
                    "coordinate": {
                        "latitude": -26.060142,
                        "longitude": 28.060374
                    },
                    "distance": 12.222816237212735,
                    "type": {
                        "typeId": 4,
                        "description": "Vodacom Shop"
                    },
                    "stockReservationEnable": true,
                    "upgradeToCollectEnable": true,
                    "stockCode": null,
                    "quantity": 0,
                    "inStock": false,
                    "lastUpdate": null
                },
                {
                    "storeID": 1510,
                    "shopCode": "POSTEST1997",
                    "name": "TEST VODACOM SHOP VODACOM WORLD",
                    "addressLineOne": "082 Vodacom Boulevard",
                    "addressLineTwo": "Shop 7, Vodacom World ",
                    "city": "Midrand",
                    "district": "Johannesburg",
                    "state": "Southern Gauteng",
                    "country": "ZA",
                    "postalCode": "1682",
                    "mainPhone": "27116536750",
                    "email": "hitesh.buwade@vcontractor.co.za",
                    "alternativePhone": null,
                    "mobilePhone": null,
                    "fax": null,
                    "paymentTypes": [
                        {
                            "paymentTypeDescription": null,
                            "paymentTypeId": 0
                        }
                    ],
                    "additionalPhone": null,
                    "tradingHours": [
                        {
                            "dayOfWeek": 0,
                            "startTime": 0,
                            "endTime": 0
                        }
                    ],
                    "bir": true,
                    "storeCategory": {
                        "categoryID": 3,
                        "description": "Super Premium"
                    },
                    "open": true,
                    "coordinate": {
                        "latitude": -25.970113,
                        "longitude": 28.128212
                    },
                    "distance": 0.142907789240403,
                    "type": {
                        "typeId": 4,
                        "description": "Vodacom Shop"
                    },
                    "stockReservationEnable": true,
                    "upgradeToCollectEnable": true,
                    "stockCode": null,
                    "quantity": 0,
                    "inStock": false,
                    "lastUpdate": null
                },
                {
                    "storeID": 1384,
                    "shopCode": "27277",
                    "name": "VODACOM SHOP WOODMEAD RETAIL PARK",
                    "addressLineOne": "1 Waterval Street",
                    "addressLineTwo": "Shop 3A and 4, Woodmead Retail Park",
                    "city": "Woodmead Ext 40",
                    "district": "Johannesburg",
                    "state": "Southern Gauteng",
                    "country": "ZA",
                    "postalCode": "2191",
                    "mainPhone": "27116569598",
                    "email": "OmniBBDDevTeam@vodacom.co.za",
                    "alternativePhone": null,
                    "mobilePhone": null,
                    "fax": null,
                    "paymentTypes": [
                        {
                            "paymentTypeDescription": null,
                            "paymentTypeId": 0
                        }
                    ],
                    "additionalPhone": null,
                    "tradingHours": [
                        {
                            "dayOfWeek": 0,
                            "startTime": 0,
                            "endTime": 0
                        }
                    ],
                    "bir": false,
                    "storeCategory": {
                        "categoryID": 1,
                        "description": "Standard"
                    },
                    "open": true,
                    "coordinate": {
                        "latitude": -26.047415,
                        "longitude": 28.080078
                    },
                    "distance": 9.986754721365912,
                    "type": {
                        "typeId": 4,
                        "description": "Vodacom Shop"
                    },
                    "stockReservationEnable": true,
                    "upgradeToCollectEnable": true,
                    "stockCode": null,
                    "quantity": 0,
                    "inStock": false,
                    "lastUpdate": null
                },
                {
                    "storeID": 1373,
                    "shopCode": "VWOR1",
                    "name": "VODACOM SHOP VODACOM WORLD",
                    "addressLineOne": "082 Vodacom Boulevard",
                    "addressLineTwo": "Shop 7, Vodacom World ",
                    "city": "Midrand",
                    "district": "Johannesburg",
                    "state": "Southern Gauteng",
                    "country": "ZA",
                    "postalCode": "1682",
                    "mainPhone": "27116536750",
                    "email": "OmniBBDDevTeam@vodacom.co.za",
                    "alternativePhone": null,
                    "mobilePhone": null,
                    "fax": null,
                    "paymentTypes": [
                        {
                            "paymentTypeDescription": null,
                            "paymentTypeId": 0
                        }
                    ],
                    "additionalPhone": null,
                    "tradingHours": [
                        {
                            "dayOfWeek": 0,
                            "startTime": 0,
                            "endTime": 0
                        }
                    ],
                    "bir": true,
                    "storeCategory": {
                        "categoryID": 3,
                        "description": "Super Premium"
                    },
                    "open": true,
                    "coordinate": {
                        "latitude": -25.970113,
                        "longitude": 28.128212
                    },
                    "distance": 0.142907789240403,
                    "type": {
                        "typeId": 4,
                        "description": "Vodacom Shop"
                    },
                    "stockReservationEnable": false,
                    "upgradeToCollectEnable": false,
                    "stockCode": "0000000103004940",
                    "quantity": 98,
                    "inStock": true,
                    "lastUpdate": "2020-09-14T13:03:55.0"
                },
                {
                    "storeID": 1366,
                    "shopCode": "36401",
                    "name": "VODACOM SHOP THEMBISA BIRCH ACRES ",
                    "addressLineOne": "Corner Isimuku Street and Andrew Mapheto Drive",
                    "addressLineTwo": "Shop 51C, Birch Acres Mall",
                    "city": "Birch Acres",
                    "district": "Johannesburg",
                    "state": "Southern Gauteng",
                    "country": "ZA",
                    "postalCode": "1618",
                    "mainPhone": "27721440826",
                    "email": "OmniBBDDevTeam@vodacom.co.za",
                    "alternativePhone": null,
                    "mobilePhone": null,
                    "fax": null,
                    "paymentTypes": [
                        {
                            "paymentTypeDescription": null,
                            "paymentTypeId": 0
                        }
                    ],
                    "additionalPhone": null,
                    "tradingHours": [
                        {
                            "dayOfWeek": 0,
                            "startTime": 0,
                            "endTime": 0
                        }
                    ],
                    "bir": false,
                    "storeCategory": {
                        "categoryID": 4,
                        "description": "Emerging Market"
                    },
                    "open": true,
                    "coordinate": {
                        "latitude": -26.034944,
                        "longitude": 28.19142
                    },
                    "distance": 9.670766171614137,
                    "type": {
                        "typeId": 4,
                        "description": "Vodacom Shop"
                    },
                    "stockReservationEnable": true,
                    "upgradeToCollectEnable": true,
                    "stockCode": null,
                    "quantity": 0,
                    "inStock": false,
                    "lastUpdate": null
                },
                {
                    "storeID": 1206,
                    "shopCode": "13212",
                    "name": "VODACOM SHOP CENTURION MALL",
                    "addressLineOne": "Heuwel Avenue, Entrance 5",
                    "addressLineTwo": "Shop 268B, Centurion Shopping Centre",
                    "city": "Centurion",
                    "district": "Pretoria",
                    "state": "Northern Gauteng",
                    "country": "ZA",
                    "postalCode": "1049",
                    "mainPhone": "+27183923495",
                    "email": "OmniBBDDevTeam@vodacom.co.za",
                    "alternativePhone": null,
                    "mobilePhone": null,
                    "fax": null,
                    "paymentTypes": [
                        {
                            "paymentTypeDescription": null,
                            "paymentTypeId": 0
                        }
                    ],
                    "additionalPhone": null,
                    "tradingHours": [
                        {
                            "dayOfWeek": 0,
                            "startTime": 0,
                            "endTime": 0
                        }
                    ],
                    "bir": false,
                    "storeCategory": {
                        "categoryID": 2,
                        "description": "Premium"
                    },
                    "open": true,
                    "coordinate": {
                        "latitude": -25.856605,
                        "longitude": 28.184833
                    },
                    "distance": 13.69392629113139,
                    "type": {
                        "typeId": 4,
                        "description": "Vodacom Shop"
                    },
                    "stockReservationEnable": true,
                    "upgradeToCollectEnable": true,
                    "stockCode": null,
                    "quantity": 0,
                    "inStock": false,
                    "lastUpdate": null
                },
                {
                    "storeID": 1365,
                    "shopCode": "37723",
                    "name": "VODACOM SHOP THE REDS",
                    "addressLineOne": "Corner Hendrik Verwoerd and Rooihuiskraal Drives",
                    "addressLineTwo": "Shop 15 and 16, Mall @ Reds",
                    "city": "Rooihuiskraal",
                    "district": "Pretoria",
                    "state": "Northern Gauteng",
                    "country": "ZA",
                    "postalCode": "0157",
                    "mainPhone": "27126569567",
                    "email": "OmniBBDDevTeam@vodacom.co.za",
                    "alternativePhone": null,
                    "mobilePhone": null,
                    "fax": null,
                    "paymentTypes": [
                        {
                            "paymentTypeDescription": null,
                            "paymentTypeId": 0
                        }
                    ],
                    "additionalPhone": null,
                    "tradingHours": [
                        {
                            "dayOfWeek": 0,
                            "startTime": 0,
                            "endTime": 0
                        }
                    ],
                    "bir": true,
                    "storeCategory": {
                        "categoryID": 2,
                        "description": "Premium"
                    },
                    "open": true,
                    "coordinate": {
                        "latitude": -25.895967,
                        "longitude": 28.156153
                    },
                    "distance": 8.563258521616842,
                    "type": {
                        "typeId": 4,
                        "description": "Vodacom Shop"
                    },
                    "stockReservationEnable": false,
                    "upgradeToCollectEnable": false,
                    "stockCode": "0000000103004940",
                    "quantity": 297,
                    "inStock": true,
                    "lastUpdate": "2020-08-17T01:23:37.0"
                },
                {
                    "storeID": 1228,
                    "shopCode": "VDSFR",
                    "name": "VODACOM SHOP FOURWAYS",
                    "addressLineOne": "Corner William Nicol and Witkoppen Street",
                    "addressLineTwo": "Shop G100A, Fourways Mall",
                    "city": "Fourways",
                    "district": "Johannesburg",
                    "state": "Southern Gauteng",
                    "country": "ZA",
                    "postalCode": "2191",
                    "mainPhone": "27114658104",
                    "email": "OmniBBDDevTeam@vodacom.co.za",
                    "alternativePhone": null,
                    "mobilePhone": null,
                    "fax": null,
                    "paymentTypes": [
                        {
                            "paymentTypeDescription": null,
                            "paymentTypeId": 0
                        }
                    ],
                    "additionalPhone": null,
                    "tradingHours": [
                        {
                            "dayOfWeek": 0,
                            "startTime": 0,
                            "endTime": 0
                        }
                    ],
                    "bir": true,
                    "storeCategory": {
                        "categoryID": 3,
                        "description": "Super Premium"
                    },
                    "open": true,
                    "coordinate": {
                        "latitude": -26.022339,
                        "longitude": 28.008699
                    },
                    "distance": 13.37037840001163,
                    "type": {
                        "typeId": 4,
                        "description": "Vodacom Shop"
                    },
                    "stockReservationEnable": false,
                    "upgradeToCollectEnable": false,
                    "stockCode": "0000000103004940",
                    "quantity": 2640,
                    "inStock": true,
                    "lastUpdate": "2020-08-17T01:42:04.0"
                }
            ]
        },
        "successful": false,
        "code": 0
    }
}


export const deliveryDetailsCBU = {
    "id": "ddbef899-9c1c-4fcc-8a68-ba86b236a69c",
    "analyticTitle": "Delivery details landing page",
    "sections": [
        {
            "type": "paragraph_list",
            "id": "f84fe31a-f972-4e91-9160-9c0057406496",
            "analyticTitle": "Delivery details",
            "title": "How would you like to receive your order?",
            "items": [
                {
                    "id": "552e8d89-0eb3-4258-8cec-97d3e69c34de",
                    "title": "Deliver via courier",
                    "description": "<p><strong>Standard delivery</strong></p><ul>\t<li>Since your order is over {order_amount}, your delivery is FREE</li>\t<li>Deliveries normally take 3 - 4 business days</li>\t<li>Deliveries are made on weekdays between 08:00 and 17:00</li></ul>"
                },
                {
                    "id": "52847d96-fc89-41c1-9f71-6362c5ff503c",
                    "title": "Collect in store",
                    "description": "<p><strong>Collecting from a store</strong></p><ul>\t<li>We've made sure we only show you stores that have your items in stock. If you can't find your favourite store below, it may be that they don't have stock right now.</li>\t<li>The store you choose will let you know when your order is ready for collection. It normally takes 1 - 3 days to prepare your order.</li>\t<li>Collections can be made during normal store operating hours.</li></ul>"
                }
            ],
            "icon": "https://wwwdev.vodacom.co.za/sites/vodacomcoza/files/2021-09/Path.svg"
        }
    ],
    "status": "success"
}